<div [ngClass]="{'col-12 col-xl-8' : !allSettings}">
  <div class="card" >
    <div class="card-header mb-3">
      <h5 class="card-title mb-0">{{ 'lumAlarmsTitle' | translate }}</h5>
      <h6 class="card-subtitle text-muted mt-1">{{ 'lumAlarmsDesc' | translate }}</h6>
    </div>

    <div class="card-body d-flex align-items-center justify-content-center py-5 " *ngIf="loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'loading' | translate }}</span>
      </div>
    </div>

    <div class="card-body py-0 " *ngIf="!loading && alarmsData">
      <div>{{ 'lumAlarmsTitle' | translate }}: {{ alarmsList.length }} / {{ ALARM_MAX }}</div>
    </div>

    <div class="card-body" *ngIf="!loading && alarmsData && alarmsList.length === 0">
      <div class="border border-2 border-dashed rounded-3 bg-light bg-opacity-25 d-flex align-items-center justify-content-center py-5">
        <div class="text-center text-muted px-4">
          <i class="fas fa-bell fa-2x mb-3 opacity-50"></i>
          <p class="mb-0 small fw-semibold">{{ 'lumAlarmsEmptyTitle' | translate }}</p>
          <p class="mb-0 small opacity-75">{{ 'lumAlarmsEmptyHint' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="card-body pt-0" *ngIf="!loading && alarmsList?.length > 0">
      <div class="table-responsive">
        <table class="table table-sm table-striped align-middle mb-0">
          <thead>
            <tr>
              <th class="text-nowrap" >{{ 'name' | translate }}</th>
              <th class="text-nowrap" [title]="'lumAlarmTriggeredHint' | translate">{{ 'lumAlarmTriggered' | translate }}</th>
              <th class="text-nowrap">{{ 'lumAlarmVariable' | translate }}</th>
              <th class="text-nowrap">{{ 'lumAlarmCondition' | translate }}</th>
              <th class="text-nowrap">{{ 'lumAlarmValue' | translate }}</th>
              <th class="text-nowrap">{{ 'lumAlarmHysteresis' | translate }}</th>
              <th class="text-nowrap" [title]="'lumAlarmHoldFor' | translate">{{ 'lumAlarmDelay' | translate }}</th>
              <th class="text-nowrap" [title]="'lumAlarmCheckEvery' | translate">{{ 'lumAlarmSampling' | translate }}</th>
              <th class="text-nowrap">{{ 'lumAlarmAction' | translate }}</th>
              <th class="text-nowrap">{{ 'lumAlarmReset' | translate }}</th>
              <th class="text-nowrap">{{ 'actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let alarm of alarmsList">
              <td class="text-nowrap ">{{ alarm.cfg?.name || '--' }}</td>
              <td class="text-nowrap">
                <span *ngIf="isAlarmTriggered(alarm); else alarmIdle" class="badge rounded-pill bg-warning text-white">
                  {{ 'yes' | translate }}
                </span>
                <ng-template #alarmIdle>
                  <span class="text-muted">{{ 'no' | translate }}</span>
                </ng-template>
              </td>
              <td class="text-nowrap">{{ getVariableName(alarm) | translate }}</td>
              <td class="text-nowrap">
                <ng-container *ngIf="getThresholdTypeKey(alarm) as typeKey; else noThresholdType">{{ typeKey | translate }}</ng-container>
                <ng-template #noThresholdType>--</ng-template>
              </td>
              <td class="text-nowrap">{{ alarm.cfg?.threshold_type === 'MIN_MAX' ? (alarm.cfg?.threshold_min + ' - ' + alarm.cfg?.threshold_max) : alarm.cfg?.threshold ?? '--' }} {{ getUnitForValue(alarm.cfg) }}</td>
              <td class="text-nowrap">{{ alarm.cfg?.threshold_type === 'MIN_MAX' ? (alarm.cfg?.hysteresis_min + ' - ' + alarm.cfg?.hysteresis_max) : alarm.cfg?.hysteresis ?? '--' }} {{ getUnitForValue(alarm.cfg) }}</td>
              <td class="text-nowrap">{{ alarm.cfg?.trigger_delay/1000  }} s</td>
              <td class="text-nowrap">{{ alarm.cfg?.read_interval/1000  }} s</td>
              <td class="text-nowrap">
                <ng-container *ngIf="alarm.cfg?.trigger_actions?.[0]?.action as action; else notificationOnly">
                  {{ 'lumAlarmComponentRelayNotification' | translate }}
                  <span class="text-muted">({{ (action === 'off' ? 'lumAlarmActionOff' : 'lumAlarmActionOn') | translate }})</span>
                </ng-container>
                <ng-template #notificationOnly>{{ 'lumAlarmComponentNotification' | translate }}</ng-template>
              </td>
              <td class="text-nowrap">
                <ng-container *ngIf="isAutoCleanEnabled(alarm); else autoCleanDisabled">
                  {{ 'yes' | translate }}
                  <span class="text-muted">({{ getAutoCleanSeconds(alarm) }} s)</span>
                </ng-container>
                <ng-template #autoCleanDisabled>{{ 'no' | translate }}</ng-template>
              </td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <label class="switch-sm mb-0">
                    <input
                      type="checkbox"
                      [id]="'lumAlarmEnabled-' + alarm.id"
                      [name]="'lumAlarmEnabled-' + alarm.id"
                      [checked]="isAlarmEnabled(alarm)"
                      [disabled]="loading"
                      [attr.aria-label]="'lumAlarmEnabled' | translate"
                      (change)="toggleAlarmEnabled(alarm, $event)">
                    <span class="slider round"></span>
                  </label>
                  <button type="button" class="btn btn-sm btn-link p-0 text-primary fs-6"
                    [disabled]="loading"
                    (click)="openEditAlarmModal(alarm)"
                    [attr.aria-label]="'edit' | translate"
                    [title]="'edit' | translate">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-link p-0 text-danger fs-6"
                    [disabled]="loading"
                    (click)="deleteAlarm(alarm)"
                    [attr.aria-label]="'delete' | translate"
                    [title]="'delete' | translate">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card-body" *ngIf="!loading && !alarmsData">
      <div class="alert alert-warning mb-0" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>{{ 'lumAlarmsLoadError' | translate }}
      </div>
    </div>

    <div class="card-body pt-0 pb-3" *ngIf="!loading && alarmsData">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-primary" (click)="openNewAlarmModal()"
          [attr.aria-label]="'lumAlarmNewTitle' | translate"
          [title]="'lumAlarmNewTitle' | translate"
          [disabled]="alarmsList.length >= ALARM_MAX">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</div>
